import { CheckCircle } from "@phosphor-icons/react";
import { btnPrimary, fmtDateTimeWIB, fmtIDR } from "../util";
import { CheckText, StatusPill } from "./parts";

export default function Outstanding({ items, onOpen, onApprove, busy, compact }) {
    if (!items) return null;
    const needs = items.filter((r) => r.status === "NEEDS_CORRECTION").length;
    const ready = items.filter((r) => r.status === "READY_FOR_OWNER").length;
    return (
        <section className="bg-white border border-mist rounded-sm" data-testid="outstanding-section">
            <div className="flex flex-wrap items-baseline justify-between gap-2 px-4 py-3 border-b border-mist">
                <h3 className="text-[10px] uppercase tracking-[0.25em] text-neutral-500">Closing harian yang belum disetujui · {items.length}</h3>
                <span className="text-[11px] text-neutral-500" data-testid="outstanding-counts">{ready} siap disetujui Owner · {needs} perlu dikoreksi staf</span>
            </div>
            {items.length === 0 && <div className="px-4 py-6 text-sm text-neutral-500" data-testid="outstanding-empty">Semua closing sudah disetujui.</div>}
            <ul className={compact ? "max-h-80 overflow-y-auto" : ""}>
                {items.map((r) => (
                    <li key={r.reporting_date} className="px-4 py-3 border-b border-mist/60 last:border-0 flex flex-wrap items-center gap-x-4 gap-y-1.5" data-testid={`outstanding-row-${r.reporting_date}`}>
                        <button type="button" onClick={() => onOpen(r.reporting_date)} className="font-medium text-sm underline-offset-4 hover:underline w-24 text-left" data-testid={`outstanding-open-${r.reporting_date}`}>{r.reporting_date}</button>
                        <StatusPill status={r.status} testid={`outstanding-status-${r.reporting_date}`} />
                        <span className="text-sm tabular-nums w-32">{r.total_sales_idr === null ? "—" : fmtIDR(r.total_sales_idr)}</span>
                        <span className="text-[11px] text-neutral-500">Penjualan <CheckText status={r.sales_check} /> · Uang masuk <CheckText status={r.cash_check} /></span>
                        {r.sales_first_submitted_at && <span className="text-[11px] text-neutral-400 hidden md:inline">pertama {fmtDateTimeWIB(r.sales_first_submitted_at)}</span>}
                        <span className="ml-auto">
                            {r.eligible
                                ? <button type="button" disabled={busy} onClick={() => onApprove(r.reporting_date)} className={btnPrimary} data-testid={`outstanding-approve-${r.reporting_date}`}><CheckCircle size={14} /> Setujui</button>
                                : <span className="text-[11px] text-neutral-500">{r.block_reason}</span>}
                        </span>
                    </li>
                ))}
            </ul>
        </section>
    );
}
